import React from 'react';

import { CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

import colors from '../../../constants/colors';

const useStyles = makeStyles(() => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
    title: {
        fontSize: '18px',
        margin: '0',
        textAlign: 'center',
        color: '#2C3C44'
    },
    box: {
        display: 'flex',
        justifyContent: 'center'
    },
    circular: {
        color: colors.blue
    }
}));

const CustomSpinner = () => {
    const classes = useStyles('');

    return (
        <div className={classes.root}>
            <div className={classes.box}>
                <CircularProgress
                    size={50}
                    thickness={4}
                    value={100}
                    className={classes.circular}
                />
            </div>
        </div>
    );
}

export default CustomSpinner;